import { render, staticRenderFns } from "./commonLayout.vue?vue&type=template&id=5a3e0194&scoped=true&"
import script from "./commonLayout.vue?vue&type=script&lang=js&"
export * from "./commonLayout.vue?vue&type=script&lang=js&"
import style0 from "./commonLayout.vue?vue&type=style&index=0&id=5a3e0194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e0194",
  null
  
)

export default component.exports